import PropTypes from 'prop-types';
import React from 'react';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';

const CollectionMenu = props => {
    const { isInstructor, section, collection, deleteCollection, push } = props;

    const location = `term/${
        section.term_id
    }?section=${section.id.toString()}&editCollection=${collection.name}`;

    const onSelection = value => {
        switch (value) {
            case 'delete':
                deleteCollection(collection);
                break;
            default:
                push(location);
                break;
        }
    };
    const items = [];

    if (isInstructor) {
        items.push(
            <MenuItem
                aria-label="Edit"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="all-notes"
                tabIndex="1"
                tag="li"
                value="edit"
            >
                <i className="cl-icon cl-icon-notes" />
                Edit
            </MenuItem>
        );
    }

    if (isInstructor) {
        items.push(
            <MenuItem
                aria-label="Delete"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="delete"
                tag="li"
                value="delete"
            >
                <i className="cl-icon cl-icon-trash-o" />
                Delete
            </MenuItem>
        );
    }

    return (
        items.length > 0 && (
            <div className="react-dropdown-wrapper">
                <Wrapper className="react-dropdown" onSelection={onSelection}>
                    <Button className="react-dropdown-button">
                        <span aria-hidden>...</span>
                        <span className="aural">
                            Options for {collection.name}
                        </span>
                    </Button>
                    <Menu className="react-dropdown-menu">
                        <ul>{items}</ul>
                    </Menu>
                </Wrapper>
            </div>
        )
    );
};
CollectionMenu.propTypes = {
    isInstructor: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        id: PropTypes.number.isRequired,
    }).isRequired,
    collection: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    deleteCollection: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
};

export default CollectionMenu;



// WEBPACK FOOTER //
// ./src/components/section/collection_menu.ui.jsx